<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form :inline="true">
                            <el-form-item>
                                <el-input
                                    placeholder="请输入内容"
                                    v-model="filter.keyword"
                                    clearable
                                    @clear="onSearch()"
                                    class="input-with-select"
                                    size="mini"
                                >
                                    <el-select
                                        v-model="filter.column"
                                        slot="prepend"
                                        placeholder="请选择"
                                        size="mini"
                                        style="width: 100px"
                                    >
                                        <el-option
                                            label="标题"
                                            value="title"
                                        ></el-option>
                                        <el-option
                                            label="客户姓名"
                                            value="name"
                                        ></el-option>
                                        <el-option
                                            label="客户电话"
                                            value="phone"
                                        ></el-option>
                                        <el-option
                                            label="客户公司"
                                            value="company"
                                        ></el-option>
                                    </el-select>
                                    <el-button
                                        slot="append"
                                        icon="el-icon-search"
                                        @click="onSearch()"
                                    ></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                              <el-select v-model="filter.category" placeholder="请选择类型" size="mini" @change="onSearch" clearable @clear="onSearch">
                                <el-option v-for="category in categories" :label="category" :value="category" :key="category"/>
                              </el-select>
                            </el-form-item>
                            <el-form-item>
                              <el-select v-model="filter.domain" placeholder="请选择技术领域" size="mini" @change="onSearch" clearable @clear="onSearch">
                                <el-option v-for="domain in domains" :label="domain" :value="domain" :key="domain"/>
                              </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group
                                    v-model="filter.state"
                                    size="mini"
                                    @change="onSearch()"
                                >
                                    <el-radio-button label="所有"></el-radio-button>
                                    <el-radio-button label="已处理"></el-radio-button>
                                    <el-radio-button label="未处理"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <application-table ref="table" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApplicationTable from "./Table";

export default {
    name: "Application",
    components: {
        ApplicationTable
    },
    data: function() {
        return {
            categories:[
              '采购高科技产品',
              '开发新产品',
              '优化工艺流程',
              '技术咨询/调研',
              '其他需求'
            ],
            domains:[],
            filter: {
                state: "未处理",
                column: "title",
                keyword: null,
                category:null,
                domain: null
            }
        };
    },
    mounted() {
      const query = new window.BaaS.Query();
      query.compare('category','=','demand');
      this.$ox.service('domain').find(query,{select:['name'], orderBy:['prior']}).then(res=>{
        this.domains = res.objects.map(d=>d.name);
      })
    },
    methods: {
        onSearch() {
            this.$refs.table.loadData(1);
        }
    }
};
</script>

<style scoped>
</style>